import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/common/PageHeader";
import { Reveal } from "@/components/common/Reveal";
import { CLINIC } from "@/data/site";
import { triggerLink } from "@/lib/actions";
import { PlayCircle, Youtube } from "lucide-react";

export default function Videos() {
  const [videos, setVideos] = useState([]);
  useEffect(() => { api.get("/videos").then((r) => setVideos(r.data)).catch(() => {}); }, []);
  const grouped = videos.reduce((acc, v) => { (acc[v.category] = acc[v.category] || []).push(v); return acc; }, {});

  return (
    <>
      <Seo title="Patient Education Videos" description="Watch educational dental videos from the Center Of Dental Treatment." path="/videos" />
      <PageHeader eyebrow="Patient Education" title="Learn by watching" subtitle="Short, clear videos explaining treatments and care — from our YouTube channel." />

      <section className="py-14 lg:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8"><button onClick={() => triggerLink(CLINIC.youtube, true)} data-testid="videos-channel-link" className="inline-flex items-center gap-2 h-11 px-5 rounded-[var(--cdt-radius-sm)] bg-[var(--cdt-primary)] text-white font-semibold hover:bg-[var(--cdt-primary-2)] transition-colors"><Youtube className="h-5 w-5" /> Visit our channel</button></div>
          {Object.entries(grouped).map(([cat, list]) => (
            <div key={cat} className="mb-12">
              <h2 className="font-display text-2xl text-[var(--cdt-text)] mb-5">{cat}</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {list.map((v, i) => (
                  <Reveal key={v.id || i} delay={(i % 3) * 0.06}>
                    <button onClick={() => triggerLink(v.youtube_url, true)} data-testid={`video-card-${i}`} className="group block text-left w-full rounded-[var(--cdt-radius-md)] bg-white border border-[color:var(--cdt-border)] shadow-[var(--cdt-shadow-sm)] hover:shadow-[var(--cdt-shadow-md)] transition-shadow overflow-hidden">
                      <div className="relative h-40 bg-[var(--cdt-primary-2)] flex items-center justify-center">
                        <div className="absolute inset-0 opacity-30" style={{ background: "radial-gradient(400px 200px at 50% 40%, rgba(200,168,107,0.5), transparent 60%)" }} />
                        <PlayCircle className="h-14 w-14 text-white/90 group-hover:scale-110 transition-transform relative" />
                      </div>
                      <div className="p-4"><h3 className="font-display text-lg text-[var(--cdt-text)]">{v.title}</h3><p className="mt-1 text-sm text-[var(--cdt-muted)] leading-6">{v.description}</p></div>
                    </button>
                  </Reveal>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
